// Order method view
// Displays order method and available order methods for the order (pick up,
// eat in or delivery). Provides select element of available order methods that
// will set the order method for the order when changed
import i18n from 'i18next';
import jQuery from 'jquery';

const { UI } = Mobi2Go;
UI.View({
    name: 'order_method',
    model: 'Order',
    el: '[data-view="order-method"]',
    template: jQuery('[data-template="order-method"]').html(),
    initialise() {
        // Get langauge strings for each order method
        this.method_titles = Mobi2Go.Order.getMethodLabels();
    },
    model_listeners: {
        updateAvailableMethods: 'render',
        updateMethod: 'render',
        updateAddress: 'render',
        updateCustomer: 'render',
    },
    render() {
        const data = {
            order_method: this.model.getMethod(),
            address: this.model.getAddress(),
            available_methods: this.model.getAvailableMethods(),
            method_titles: this.method_titles,
            methods_string: this.orderMethodsString(),
            order: this.model,
        };
        const html = this.template(data); // Generate html from template
        this.$el.html(html); // Insert html into DOM
        this.trigger('orderMethodViewRendered');
    },

    orderMethodsString() {
        // e.g. Pick up or Delivery?
        const available_methods = this.model.getAvailableMethods();
        return Object.entries(this.method_titles)
            .filter(([key]) => available_methods.includes(key))
            .map(([, string]) => string)
            .join(i18n.t('order.method:or'));
    },

    // When the dropdown changes, set the order method of the order
    DOM_listeners: {
        'change [data-order-method]': function(e) {
            const order_method = e.target.value;
            this.model.setMethod(order_method, true);
        },
        'click [data-order-delivery-address]': function() {
            UI.trigger('showCustomerAddresses');
        },
    },
});
